document.addEventListener("DOMContentLoaded", function () {
    window.addEventListener("load", function () {
        let elements = document.querySelectorAll('.beforeAfterSlider');

        if (!elements.length) {
            return;
        }

        elements.forEach(function(element) {
            mySwiper = new Swiper(element.querySelector('.swiper'), {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: false,
                a11y: true,

                navigation: {
                    nextEl: element.querySelector(".swiper-button-next"),
                    prevEl: element.querySelector(".swiper-button-prev"),
                }
            });

            element.addEventListener('change', (event) => {
                if (event.target.type === 'checkbox') {
                    const slide = event.target.closest('.swiper-slide');
                    const beforeImage = slide.querySelector('.images .before');
                    const afterImage = slide.querySelector('.images .after');

                    if (event.target.checked) {
                        beforeImage.style.opacity = '0';
                        afterImage.style.opacity = '1';
                    } else {
                        beforeImage.style.opacity = '1';
                        afterImage.style.opacity = '0';
                    }
                }
            });
        });
    });
});
